import * as Effect from "effect/Effect";
export const PREVIEW_DEBOUNCE_MS = 450;
export const SAVE_DEBOUNCE_MS = 1000;
/** Debounce fibers belong to the owner's Scope and use its injected Effect Clock. */
export function makePolicies(start) {
    let preview = null;
    let save = null;
    return {
        prepare: (work) => { preview?.interruptUnsafe(); preview = start(Effect.andThen(Effect.sleep(PREVIEW_DEBOUNCE_MS), work)); },
        save: (enqueue) => {
            save?.interruptUnsafe();
            // A dispatched CAS must finish; superseding only interrupts the debounce timer.
            save = start(Effect.andThen(Effect.sleep(SAVE_DEBOUNCE_MS), Effect.sync(enqueue)));
        },
        stopPrepare: () => { preview?.interruptUnsafe(); preview = null; },
        stopSave: () => { save?.interruptUnsafe(); save = null; },
        stop: () => { preview?.interruptUnsafe(); save?.interruptUnsafe(); preview = null; save = null; },
    };
}
